import axios, { AxiosError, AxiosRequestConfig } from 'axios'
import router from '@/router'

const API_ORIGIN = (import.meta.env.VITE_API_BASE_URL as string | undefined) || ''

type Lang = 'ru' | 'kk' | 'en'

function getLang(): Lang {
  const p = router.currentRoute.value.params.lang
  const fromRoute = typeof p === 'string' ? p : Array.isArray(p) ? p[0] : ''
  const fromLS = localStorage.getItem('lang') || ''
  const isValid = (x: string) => (['ru', 'kk', 'en'] as const).includes(x as any)

  const L = isValid(fromRoute) ? fromRoute : isValid(fromLS) ? fromLS : 'ru'
  if (fromLS !== L) localStorage.setItem('lang', L)
  return L as Lang
}

function joinURL(origin: string, path: string) {
  if (!origin) return path
  return origin.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '')
}

export const api = axios.create({ withCredentials: true })
export const sys = axios.create({ withCredentials: true })

api.interceptors.request.use((config) => {
  const url = config.url || ''
  if (/^https?:\/\//i.test(url)) return config

  const lang = getLang()
  const normalized = url.startsWith('/') ? url : `/${url}`

  config.baseURL = joinURL(API_ORIGIN, `/${lang}/api/`)
  config.url = normalized
  return config
})

sys.interceptors.request.use((config) => {
  const url = config.url || ''
  if (/^https?:\/\//i.test(url)) return config

  const normalized = url.startsWith('/') ? url : `/${url}`
  config.baseURL = API_ORIGIN
  config.url = normalized
  return config
})

let isRefreshing = false
let refreshPromise: Promise<void> | null = null

function shouldTryRefresh(url?: string) {
  if (!url) return true
  return !(
    url.includes('/accounts/profile/settings/') ||
    url.includes('/api/token/') ||
    url.includes('/api/token/refresh/') ||
    url.includes('/api/logout/')
  )
}

async function refreshByCookie(): Promise<void> {
  if (isRefreshing && refreshPromise) return refreshPromise

  isRefreshing = true
  refreshPromise = sys
    .post('/api/token/refresh/', {}) // refresh токен берется из cookies
    .then(() => undefined)
    .finally(() => {
      isRefreshing = false
      refreshPromise = null
    })

  return refreshPromise
}

api.interceptors.response.use(
  (r) => r,
  async (error: AxiosError) => {
    const original = error.config as (AxiosRequestConfig & { _retry?: boolean }) | undefined
    if (!original) throw error

    if (error.response?.status === 401 && !original._retry && shouldTryRefresh(original.url)) {
      original._retry = true
      await refreshByCookie()
      return api(original)
    }
    throw error
  }
)

export default api
